// Only these two are named. Our OCR also emits ID_CARD/RESIDENCE_PERMIT/TWIC and the
// Veriff webhook stores its own vocabulary verbatim, so anything else stays generic
// rather than risking a headline like "From other".
const NAMED_TYPES: Record<string, string> = {
  DRIVERS_LICENSE: "driver's license",
  PASSPORT: 'passport',
};

/** Caption for the scanned ID, e.g. "From driver's license" or "From ID document". */
export function idDocumentCaption(type: string | null | undefined): string {
  const named = type ? NAMED_TYPES[type] : undefined;
  return `From ${named ?? 'ID document'}`;
}
